import { useCallback } from "react";
import { useQuery } from "react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../../services/Api";
import "./index.css";
import { LoadingInline } from "../LoadingInline";
import { ToastNotifier } from "../../util/ToastNotifier";

export default function EditChatbotPage() {
  const navigate = useNavigate();
  const [sendingMessage, setSendingMessage] = useState(false);

  const handleBackButton = useCallback(() => {
    navigate("/chatbot");
  }, [navigate]);

  const { data, isLoading, isRefetching, refetch } = useQuery(
    ["chatbot-prompt"],
    async () => {
      const response = await Api.get("/chatbot-prompt");
      return response.instructions;
    }
  );

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      const message = event.target.message.value;
      setSendingMessage(true);
      try {
        await Api.post("/chatbot-prompt", {
          body: {
            instructions: message,
          },
        });
        ToastNotifier.success("Prompt do chatbot salvo com sucesso!");
      } catch (error) {
        ToastNotifier.fail("Erro ao salvar o prompt do chatbot.");
      }
      await refetch();
      setSendingMessage(false);
    },
    [refetch]
  );

  if (isLoading || isRefetching) {
    return (
      <div className="loading-container">
        <LoadingInline />
      </div>
    );
  }

  return (
    <div className="page-container">
      <form className="form-container" onSubmit={handleSubmit}>
        <label className="form-label" for="message">
          Prompt do chatbot:
        </label>
        <textarea
          id="message"
          name="message"
          rows="20"
          cols="100"
          defaultValue={data}
          placeholder="Escreva o prompt aqui..."
          className="form-textarea"
        ></textarea>
        <button type="submit" className="form-button" disabled={sendingMessage}>
          {sendingMessage ? <LoadingInline /> : "Salvar"}
        </button>
        <button
          type="button"
          className="form-button back-button"
          onClick={handleBackButton}
        >
          Voltar
        </button>
      </form>
    </div>
  );
}
